import { updateBrowserControlState } from '@wg/web2clientapi/browser/updateBrowserControlState';
import { useLocation, useNavigate } from 'react-router-dom';

import { appInit } from '~/Actions/ActionApp';
import { useMount } from '~/hooks';
import { useAppDispatch } from '~/store';
import { isInGame } from '~/utils';
import { enqueueReturnNavigationOnClose } from '~/utils/externalNavigation';

const Init = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useMount(() => {
    if (isInGame) {
      enqueueReturnNavigationOnClose(location.search);
      void updateBrowserControlState(false);
    }

    dispatch(appInit(navigate, location));
  });

  return <></>;
};

export default Init;
